import { render } from "./QuizQuestion.vue?vue&type=template&id=50100ec9&scoped=true"
import script from "./QuizQuestion.vue?vue&type=script&lang=js"
export * from "./QuizQuestion.vue?vue&type=script&lang=js"

import "./QuizQuestion.vue?vue&type=style&index=0&id=50100ec9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50100ec9"]])

export default __exports__